import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Pages
import HomePage from "./pages/HomePage";
import InsurancePage from "./pages/InsurancePage";
import LoansPage from "./pages/LoansPage";
import InsightsPage from "./pages/InsightsPage";
import ScrollToTop from "./pages/ScrollToTop";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminLogin from "./pages/AdminLogin";
import BlogDetails from "./pages/BlogDetails";
import TermsAndConditions from "./pages/termsandconditions";
import PrivacyAndPolicy from "./pages/privacyandpolicy";
import AdminDashboard from "./pages/AdminDashboard";
import Blogs from "./pages/Blogs";
import ArticlePage from "./pages/ArticlePage";
import EnquiryPage from "./pages/EnquiryPage";
import InstaLeadsPage from "./pages/InstaLeadsPage";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-[#F5F5F7]">
      <BrowserRouter>
       <ScrollToTop />
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Admin Routes - no navbar/footer */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          
          {/* Public Routes - with navbar/footer */}
          <Route path="*" element={
            <>
              <Navbar />
              <main className="pt-20">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/insurance" element={<InsurancePage />} />
                  <Route path="/loans" element={<LoansPage />} />
                  <Route path="/insights" element={<InsightsPage />} />
                  <Route path="/insights/:id" element={<ArticlePage />} />
                  <Route path="/blogs" element={<Blogs />} />
                    <Route path="/blog/:id" element={<BlogDetails />} />
                      <Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
                      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/enquiry" element={<EnquiryPage />} />
                  <Route path="/insta-leads" element={<InstaLeadsPage />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
